"use strict";const e=require("../createBrandTheme.js"),t=e.createBrandTheme({main:"#4C42CF",light:"#928CEF",dark:"#3228B7",contrastText:"#FFFFFF"});module.exports=t;
//# sourceMappingURL=index.js.map
